<div class="innerBanner" *ngIf="this.type !='ass'">
    <div class="container md">
        <div class="viewerAssign">
            <div class="row">
                <div class="col-12 col-md-6">
                   <div class="">
                       <a href="javascript:void(0);" class="backLink" [routerLink]="['/assigned_details_resume']" [queryParams]="{courseId:courseId}"><b><img src="assets/images/icons/backarrow.png" /></b>BACK  TO COURSE DETAILS</a>
                   </div>
                   <div class="viewerModule">
                       <h2>{{moduleName}}</h2>
                       <div class="engineWrap">
                       <div class="joinerDetails mb-0">
                           <span class="joinerDetailsImage">
                               <img src="assets/images/icons/doughnut_chart.svg">
                            </span>
                            <!-- <div class="joinerContent">
                                <h3>0%</h3>
                                <div class="ghrapWrap mb-0">
                                    <span style="width: 0%;"></span>
                                </div>
                            </div> -->
                        </div>
                    </div>

                    </div>
                    <div class="viewerSubModule">
                        <div class="viewerSubTitle">
                            <span *ngIf="ModulSubData!=''">{{ModulSubData.submodule_name}}</span>
                            <h2 *ngIf="ModulSubData!=''">{{ModulSubData.submodule_desc}}</h2>
                        </div>
                        <div class="viewerModifyi">
                            <ul class="modifyIcons">
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                     
                </div>
                <!-- <div class="col-12 col-md-6">
    
                    <div class="timerWrap countdown">
                        <ul>
                            <li>
                                <div class="timer ">
                                    <span>01</span>
                                    <small>hrs</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span>10</span>
                                    <small>min</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span>34</span>
                                    <small>sec</small>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div> -->
            </div>
        </div>
    </div>
</div>

 <!-- <div class="dynamicBookWrap">
<div class="container">
    <div class="row">
        <div class="resultWrap">
            <div class="resul_img">
                <img src="assets/images/thumb-down.png" />
            </div>
             <h5>You have failed this module Assessment!</h5>
             <span class="divider red"></span>
             <p>You have 2 more attempts left to pass this assessment</p>
             <div class="btnWrap mb-3 pb-3">
                <a href="javascript:void(0);" class="btn btn-primary btn-sm">Try Again now</a>
             </div>
        <div class="btnWrap">
            <a href="javascript:void(0);" class="backPage">Back to course details</a>
        </div>
        </div>
    </div>
</div>
</div> -->
<div class="dynamicBookWrap"  *ngIf="this.type !='ass'">
    <div class="container">
        <div class="row">
            <div class="resultWrap">
                <div class="resul_img">
                    <img src="assets/images/thumb-down.png" />
                </div>
                 <h5 *ngIf="this.assessmentType==1">You have failed this module Assessment!</h5>
                 <h5 *ngIf="this.assessmentType==0">You have failed this submodule Assessment!</h5>
                 <span class="divider red"></span>
                 <p *ngIf="3 - (EvaluationResultFail.attempt_num-1) != 0">You have {{3 - (EvaluationResultFail.attempt_num-1)}} more attempts left to pass this assessment</p>
                 <p *ngIf="3 - (EvaluationResultFail.attempt_num-1) == 0">You have no more attempts left to pass this assessment</p>
                 <div class="btnWrap mb-3 pb-3" *ngIf="3-(EvaluationResultFail.attempt_num-1) !=0 && this.assessmentType==0">
                    <a href="javascript:void(0);" class="btn btn-primary btn-sm" [routerLink]="['/viewer-details']" 
                    [queryParams]="{course_id:courseId, module_id:moduleId,submodule_id:submoduleId,assId:assId,AT:assessmentType}">Try Again now</a>
                 </div>
                 <div class="btnWrap mb-3 pb-3" *ngIf="3-(EvaluationResultFail.attempt_num-1) !=0 && this.assessmentType==1">
                    <a href="javascript:void(0);" class="btn btn-primary btn-sm" [routerLink]="['/viewer-details']" 
                    [queryParams]="{course_id:courseId, module_id:moduleId,assId:assId,AT:assessmentType}">Try Again now</a>
                 </div>
                 <div class="btnWrap mb-3 pb-3" *ngIf="3-(EvaluationResultFail.attempt_num-1)==0">
                    <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" (click)="open(content)">
                        <span>Contact Admin</span>
                    </a>
                 </div>
            <div class="btnWrap">
                <a href="javascript:void(0);" class="backPage" [routerLink]="['/assigned_details_resume']" [queryParams]="{courseId:courseId}">Back to course details</a>
            </div>
            </div>
        </div>
    </div>
    <input type="hidden" (click)="open1(multiloginValidation)" id="successMsg">
</div>

    <div class="dynamicBookWrap" *ngIf="this.type =='ass'">
        <div class="container">
            <div class="row">
                <div class="resultWrap">
                    <div class="resul_img">
                        <img src="assets/images/thumb-down.png" />
                    </div>
                     <h5>You have failed this Assessment!</h5>
                     <span class="divider red"></span>
                     <p *ngIf="3 - (EvaluationResultFail.attempt_num) != 0">You have {{3 - (EvaluationResultFail.attempt_num)}} more attempts left to pass this assessment</p>

                     <p *ngIf="3 - (EvaluationResultFail.attempt_num) == 0">You have no more attempts left to pass this assessment</p>

                     <div class="btnWrap mb-3 pb-3" *ngIf="3-(EvaluationResultFail.attempt_num) !=0">
                        <a href="javascript:void(0);" class="btn btn-primary btn-sm" [routerLink]="['/viewer-assessment']"
                        [queryParams]="{assId: this.assId,AT:0 }">Try Again now</a>
                     </div>
                    
                     <div class="btnWrap mb-3 pb-3" *ngIf="3-(EvaluationResultFail.attempt_num)==0">
                        <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" (click)="open(content)">
                            <span>Contact Admin</span>
                        </a>
                     </div>
                <div class="btnWrap">
                    <a href="javascript:void(0);" class="backPage" [routerLink]="['/assessments']">Back to Assessments</a>
                </div>
                </div>
            </div>
        </div>
        <input type="hidden" (click)="open1(multiloginValidation)" id="successMsg">
        </div>

    <ng-template #content let-modal>
        <div class="modal-body">
            <div class="holdPopup text-center">
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click'); backToDetailPage('')">
                    <span aria-hidden="true">&times;</span>
                  </button>
                <figure>
                    <img src="assets/images/hourglass.png">
                </figure>
                <h6>Hold Tight!</h6>
                <p>Your request to increase the number of attempts available for assessments, has been sent to the administrator for review and approval.</p>
            
            <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" (click)="modal.close('Close click'); backToDetailPage('ass')">
                <span>Close</span>
            </a>
        </div>
        </div>
      </ng-template>
      <ng-template #multiloginValidation let-modal>
        <div class="modal-body">
            <div class="holdPopup text-center">
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div>
                    <p class="size18">Please logout from other devices or login again to continue using the portal here</p>
                    <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
                </div>
            </div>
        </div>
    </ng-template>
